// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avatar {
  display: inline-flex;
  align-items: center;
  gap: 1rem;
}
.avatar .profile {
  border-radius: 50%;
  max-width: 50px;
}`, "",{"version":3,"sources":["webpack://./src/components/Avatar/Avatar.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,mBAAA;EACA,SAAA;AACJ;AAAI;EACI,kBAAA;EACA,eAAA;AAER","sourcesContent":[".avatar {\n    display: inline-flex;\n    align-items: center;\n    gap: 1rem;    \n    .profile{\n        border-radius: 50%;\n        max-width: 50px;\n    }\n    .name {\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
